/**
 * Native JavaScript alternatives to lodash string functions
 */

/**
 * Converts string to camel case.
 *
 * @param str - The string to convert
 * @returns The camel cased string
 */
export function camelCase(str: string): string {
  return str
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase())
    .replace(/^[A-Z]/, char => char.toLowerCase())
    .replace(/[^a-zA-Z0-9]/g, '');
}

/**
 * Converts string to snake case.
 *
 * @param str - The string to convert
 * @returns The snake cased string
 */
export function snakeCase(str: string): string {
  return str
    .replace(/([A-Z])/g, '_$1')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
}
